<template>
    <div ref="drawer" class="sidedrawer" :class="{right: $layout.side == 'right'}" @click="close">
        <div  class="drawer" @click.stop="doNothing"> 
            <header>
                <i class="material-icons" @click.stop="close">close</i>
            </header>
            <p class="drawerLink" @click.stop="() => navigate('/')"><img src="/assets/modules_icons/drawer_icons/home.png" alt="">{{ text.home }}</p>
            <DrawerLink v-for="module in modules" :key="module[0]" :module="module" @close="close"/>
            <br>
            <p v-if="!$sharedStore.state.user_id" class="drawerLink" @click.stop="() => navigate('/login')"><img src="/assets/modules_icons/drawer_icons/connexion.png" alt="">
                {{ text.connection }}
            </p>
            <p v-else class="drawerLink" @click.stop="() => navigate('/logout')"><img src="/assets/modules_icons/drawer_icons/connexion.png" alt="">
                {{ text.deconnection }}
            </p>
            <!-- <div class="lang-box">
                <div class="lang-label">
                    <p>{{ text.langs }}</p>
                </div>
                <div class="lang-list">
                    <div v-for="lang in $langs" :key="lang.code" class="lang-item"><img :src="lang.icon" @click="() => {setLocale(lang.code)}">{{ lang.name }}</div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { setTimeout } from 'timers';
import DrawerLink from '@/components/DrawerLink'
export default {
    components: {
        DrawerLink
    },
    computed: {
        text(){
            return this.$texts[this.$i18n.locale].sideDrawer
        },
        modules(){
            return Object.entries(this.$modules)
        }
    },
    methods: {
        close(){
            this.$refs.drawer.classList.add('outing')
            setTimeout(() => {
                this.$eventBus.$emit('toggleDrawer')
            }, 250)
        },
        doNothing(){
            return true
        },
        setLocale(locale){
            this.$i18n.locale = locale
            this.$sharedStore.set('locale', locale)
        },
        navigate(route){
            this.close()
            if(this.$route.path != route){
                this.$router.pushWithEvent(route)
            }
        }
    }
}
</script>

<style lang="scss">

    .sidedrawer {
        //animation-name: background;
        //animation-duration: 0.25s;

        .drawer {
            animation-name: fromLeft;
            animation-duration: 0.25s;
        }
    }

    .right {
        &.sidedrawer {
            //animation-name: background;
            //animation-duration: 0.25s;

            .drawer {
                animation-name: fromRight;
                animation-duration: 0.25s;
            }
        }
    }
    .sidedrawer.outing {
        //animation-name: backgroundLeave;
        //animation-duration: 0.25s;

        .drawer {
            animation-name: toLeft;
            animation-duration: 0.25s;
        }
    }

    .right {
        &.sidedrawer.outing {
            //animation-name: backgroundLeave;
            //animation-duration: 0.25s;

            .drawer {
                animation-name: toRight;
                animation-duration: 0.25s;
            }
        }
    }

    .sidedrawer {
        height: vh(100);
        width: 100vw;
        display:flex;
        //background-color: rgba(50, 50, 50, 0.6);
        position: fixed;

        .drawer {
            background-color: white;
            border-right: 4px solid #E6E6E6;
            width: 85%;
            height: 100%;
            padding: 2%;
            * {
                color: #575756;
            }
            overflow-y: scroll;

            header {
                display: flex;
                flex-direction: row-reverse;
                justify-content: space-between;
                align-items: center;
                padding: 5%;

                i {
                    font-size: 1.9rem;
                }
            }

            .drawerLink {
                font-family: $titleFont;
                font-weight: bold;
                padding: 3% 5%;
                display: flex;
                align-items: center;

                img {
                    height: 100%;
                    width: 30px;
                    object-fit: contain;
                    margin-right: 15px;
                }
            }
        }
    }
    .right {
        flex-direction: row-reverse;
        
        header {
            flex-direction: row-reverse;
        }
        p {
            text-align: right;
        }
    }

    .lang-box {
        display: flex;
        padding: 1% 5%;

        .lang-label {
            width: 50%;
            display: flex;
            justify-content: center;
            flex-direction: row-reverse;

            p {
                margin: 0 15px;
                font-family: $titleFont;
                font-weight: bold;
            }
        }

        .lang-list {
            .lang-item {
                display: flex;
                align-items: center;
                font-size: 12px;
                margin: 0 15px 17px 15px;

                img {
                    width: 20px;
                    height: 20px;
                    border-radius: 1000px;
                    object-fit: cover;
                    overflow: hidden;
                    margin-right: 15px;
                }
            }
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1280px) {
        .sidedrawer {
            .drawer {
                width: 50%;
            }
        }

        @keyframes fromLeft {
            from {
                margin-left: -50%
            }
            to {
                margin-left: 0;
            }
        }

        @keyframes fromRight {
            from {
                margin-right: -50%
            }
            to {
                margin-right: 0;
            }
        }

        @keyframes toLeft {
            from {
                margin-left: 0;
            }
            to {
                margin-left: -50%;
            }
        }

        @keyframes toRight {
            from {
                margin-right: 0;
            }
            to {
                margin-right: -50%;
            }
        }
    }

    @media screen and (min-width: 1024px) {
        .sidedrawer {
            .drawer {
                width: 30%;
            }
        }

        @keyframes fromLeft {
            from {
                margin-left: -30%
            }
            to {
                margin-left: 0;
            }
        }

        @keyframes fromRight {
            from {
                margin-right: -30%
            }
            to {
                margin-right: 0;
            }
        }

        @keyframes toLeft {
            from {
                margin-left: 0;
            }
            to {
                margin-left: -30%;
            }
        }

        @keyframes toRight {
            from {
                margin-right: 0;
            }
            to {
                margin-right: -30%;
            }
        }
    }

    @keyframes background {
        from {
            background-color: rgba(50, 50, 50, 0)
        }
        to {
            background-color: rgba(50, 50, 50, 0.6)
        }
    }

    @keyframes backgroundLeave {
        from {
            background-color: rgba(50, 50, 50, 0.6)
        }
        to {
            background-color: rgba(50, 50, 50, 0)
        }
    }

    @keyframes fromLeft {
        from {
            margin-left: -85%
        }
        to {
            margin-left: 0;
        }
    }

    @keyframes fromRight {
        from {
            margin-right: -85%
        }
        to {
            margin-right: 0;
        }
    }

    @keyframes toLeft {
        from {
            margin-left: 0;
        }
        to {
            margin-left: -85%;
        }
    }

    @keyframes toRight {
        from {
            margin-right: 0;
        }
        to {
            margin-right: -85%;
        }
    }
</style>